<template>
    <div
        v-if="hasLinks"
        v-editable="blok"
        data-test="NewL4Links"
        class="l4-links"
        :style="{ backgroundColor: background }"
    >
        <div class="l4-links__container md:container">
            <h2 v-if="heading" class="l4-links__title">{{ heading }}</h2>
            <ul class="l4-links__list">
                <li v-for="link in links?.[0]?.top_level_links" :key="link._uid" class="l4-links__item">
                    <NuxtLink :to="getL4InternalLink(link.url)" class="l4-links__link" external>
                        {{ link.text }}
                    </NuxtLink>
                </li>
            </ul>
        </div>
    </div>
</template>

<script setup lang="ts">
import type { IL4LinksConfig } from '~/types/components/L4Links';

const { blok } = defineProps<{ blok: IL4LinksConfig }>();
const { heading, links, background } = blok;

const hasLinks: ComputedRef<boolean> = computed(() => !!links?.[0]?.top_level_links?.length);
</script>

<style scoped lang="postcss">
.l4-links {
    @apply px-4 md:px-4 pt-10 pb-4 text-bodypurple;
    &__title {
        @apply mb-10 font-semibold text-xl;
    }
    &__list {
        @apply flex flex-wrap;
    }
    &__item {
        @apply w-full sm:w-1/2 md:w-1/4 min-h-[50px];
    }
    &__link {
        @apply hover:underline;
    }
}
</style>
